<template>
  <div>    
    <vx-card v-if="this.mantenimiento" card-border class="mb-4" title="MANTENIMIENTO ACTIVADO" title-color="dark" collapseAction>
      <div class="vx-row w-full">
        <div class="vx-col w-full">
          <vs-alert color="danger" icon-pack="feather" icon="icon-info">
            <span>No se pueden crear operaciones nuevas mientras no termine el mantenimiento.</span>
          </vs-alert>
        </div>
      </div>
    </vx-card>
    <vx-card v-else card-border class="mb-4" title="BIENVENIDO!" title-color="dark" collapseAction>      
      <div class="vx-row w-full">
        <div class="vx-col w-full">
          &nbsp;
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import commonComponentsStore from '@/store/common-components/index.js'
import empresasStore from '@/store/configuracion/empresas/index.js'

export default{
  data () {
    return {
      role: this.userRole([this.$store.state.AppActiveUser.userRole]),
      mantenimiento: null
    }
  },
  methods: {
    userRole (role) {
      this.$store.dispatch('updateUserRole', {aclChangeRole: this.$acl.change, userRole: role})
    }
  },
  async created () {
    this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
    if (!commonComponentsStore.isRegistered) {
      this.$store.registerModule('commonComponentsStore', commonComponentsStore)
      commonComponentsStore.isRegistered = true
    }

    if (!empresasStore.isRegistered) {
      this.$store.registerModule('empresasStore', empresasStore)
      empresasStore.isRegistered = true
    }
    
    const empresaId = 1

    await this.$store.dispatch('empresasStore/getMantenimiento', empresaId)
    this.mantenimiento = this.$store.state.empresasStore.mantenimiento 
    
    await this.$store.dispatch('commonComponentsStore/getMunicipios')
    await this.$store.dispatch('commonComponentsStore/getProvincias')
    await this.$store.dispatch('commonComponentsStore/getTiposClientes')
    await this.$store.dispatch('commonComponentsStore/getOperadores')
    await this.$store.dispatch('commonComponentsStore/getEstados').then(() => this.$vs.loading.close())
  }
}
</script>